import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LuSearchCheck } from "react-icons/lu";
import { hasDraft } from "../../utils/propertyRequestDraft";

// Home entry of "Je recherche un bien", with "Reprendre ma recherche" when a draft exists in this tab.
export default function PropertyRequestHomeCta() {
  const { t } = useTranslation();
  const [draft] = useState(() => hasDraft());
  return (
    <section className="lina-property-request-cta fade-in rounded-3xl border border-green-100 bg-green-50 px-5 py-6 sm:px-8 sm:py-8" aria-labelledby="property-request-cta-title">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white text-green-700 sm:flex"><LuSearchCheck size={24} aria-hidden="true" /></span>
          <div>
            <h2 id="property-request-cta-title" className="text-2xl font-extrabold text-slate-900">{t("propertyRequest.home.title")}</h2>
            <p className="mt-1 text-base text-slate-700">{t("propertyRequest.home.lead")}</p>
          </div>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
          {draft && <Link to="/property-request/new" className="lina-action-primary min-h-[44px]">{t("propertyRequest.home.resume")}</Link>}
          <Link to="/property-request/new" className={`${draft ? "lina-action" : "lina-action-primary"} min-h-[44px]`}>{t("propertyRequest.home.start")}</Link>
          <Link to="/property-requests" className="lina-action min-h-[44px]">{t("propertyRequest.home.browse")}</Link>
        </div>
      </div>
    </section>
  );
}
